// The Portalia mark, for the web portal.
//
// Mirrors packages/mobile/components/PortaliaMark.tsx: same proportions,
// flattened from /branding/appicon.svg, same literal brand colours. A logo is
// the one thing that must NOT follow the theme — it is a fixed identity — so
// these hexes are deliberate and are the only literal colours in portal UI.
//
// Shown where a tenant has no logo of its own. A tenant logo still wins, which
// is why this is a fallback rather than a header fixture.

const BLUE = '#2477ED';
const GREEN = '#42D06E';

// The 513×513 artboard, as viewBox units.
const X = 78.43;
const W = 434.13 - 78.43;
const H = 243.89 - 80.39;
const BLUE_Y = 80.39;
const GREEN_Y = 269.03;
const R = 6;

export function PortaliaMark({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 513 513"
      role="img"
      aria-label="Portalia"
      className={className}
      focusable="false"
    >
      <rect x={X} y={BLUE_Y} width={W} height={H} rx={R} fill={BLUE} />
      <rect x={X} y={GREEN_Y} width={W} height={H} rx={R} fill={GREEN} />
    </svg>
  );
}
